'use client'

import type { ComponentProps, MouseEvent } from 'react'
import Link from 'next/link'
import { track } from '@/lib/analytics/track'

type TrackedLinkProps = ComponentProps<typeof Link> & {
  event: string
  properties: Record<string, unknown>
}

export function TrackedLink({
  event,
  properties,
  onClick,
  ...props
}: TrackedLinkProps) {
  return (
    <Link
      {...props}
      onClick={(e: MouseEvent<HTMLAnchorElement>) => {
        track(event, properties)
        if (typeof onClick === 'function') onClick(e)
      }}
    />
  )
}
